import { Component, OnInit, ViewEncapsulation, ChangeDetectorRef, OnDestroy } from '@angular/core';
import { AgentEmployeeService } from '../../services/agent-employee/agent-employee.service';
import { SearchTermservice } from '../../services/search/search-service.service';
import { AgentlocationService } from '../../services/agent_location/agentlocation.service';
import { Router, ActivatedRoute } from '@angular/router';
import { Http, Headers, RequestOptions, Response } from '@angular/http';
import 'rxjs/add/operator/map';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatSortModule } from '@angular/material/sort';
import { MatButtonModule, MatCheckboxModule } from '@angular/material';
import { Sort } from '@angular/material';
import { MatPaginator, MatTableDataSource, MatSort } from '@angular/material';
import { Subscription } from 'rxjs/Subscription';
import { ViewChild } from '@angular/core';
import { MatPaginatorIntl } from '@angular/material';
import { ContactUsDialogComponent } from '../contact-us-dialog/contact-us-dialog.component';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { ParemployeeSummaryComponent } from '../paremployee-summary/paremployee-summary.component';
import { ParemployeeDelDialogComponent } from '../paremployee-del-dialog/paremployee-del-dialog.component';
import { ParEmployeeService } from '../../services/par_employees/par_employees.service';
import 'rxjs/add/operator/map';
import { DeleteAgentEmployeeDialogComponent } from '../../components/delete-agent-employee-dialog/delete-agent-employee-dialog.component';
import { EmptyObservable } from 'rxjs/observable/EmptyObservable';

@Component({
  selector: 'app-par-employee',
  templateUrl: './par-employee.component.html',
  styleUrls: ['./par-employee.component.css']
})
export class ParEmployeeComponent implements OnInit {
  DocListErr: boolean = false;
  DocListErrMsg;
  employeeId: any;
  clientDisable: any;
  clientHidden: any;
  public role: string;
  noResults: any;
  ispaginationFlag: boolean;
  ispaginationFlag1:boolean;
  public employeeList: any[] = [];
  sortedData;
  pageSize = 10;
  length: any;
  PAREmployeeList: any[] = [];
  clientEmployeesList: any = [];
  agentId;
  message: string;
  clientData:boolean= false;
  displayedColumns = ['EmployeeId', 'FirstName', 'FileEdit'];
  displayedClientColumns = ['FirstName'];
  private subscription: Subscription;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatPaginator) paginator1: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatSort) matSort1: MatSort;
  dataSource = new MatTableDataSource<EmployeeData>();
  clientDataSource = new MatTableDataSource<clientEmployeeData>();
  empName: any;
  constructor(private router: Router, public dialog: MatDialog, private parEmployeeService: ParEmployeeService) { }
  ngOnInit() {
    let roleVal = parseInt(localStorage.getItem("RoleVal"));
    this.subscription = this.parEmployeeService.load.subscribe(res => {
      if (res === 'success') {
        this.getAllPAREmployees();
      }
    });

    this.getAllPAREmployees();

    this.role = localStorage.getItem("Role")
    if (this.role === "PC Client") {
      this.clientDisable = true;
      this.clientHidden = true;
    } else {
      this.clientDisable = false;
      this.clientHidden = false;
    }
  }
  getAllPAREmployees() {
    let roleVal = parseInt(localStorage.getItem("RoleVal"));
    if (roleVal === 8) {
      this.parEmployeeService.getClientParEmployess().subscribe(res => {
          if (res.Status == 200 && res.Employees.length <= 0) {
        this.PAREmployeeList = [];
          this.dataSource = null;
          this.ispaginationFlag = false;
          this.message = 'No employees found';
          }
          if(res.Employees.length >= 0){
        this.clientEmployeesList = [];
        for (let i = 0; i < res.Employees.length; i++) {
          res.Employees[i].FirstName = res.Employees[i].FirstName.toLowerCase();
          res.Employees[i].LastName = res.Employees[i].LastName.toLowerCase();
          this.clientEmployeesList.push(res.Employees[i])
        }
        this.clientDataSource = new MatTableDataSource(this.clientEmployeesList);
        this.length = this.clientEmployeesList.length;
          if (this.length <= 10) {
            this.ispaginationFlag1 = false;
          }
          else {
            this.ispaginationFlag1 = true;
          }
          this.paginator1.pageIndex = 0;
          this.clientDataSource.paginator = this.paginator1;
          this.clientDataSource.sort = this.matSort1;
          const paginatorIntl = new MatPaginatorIntl();
          paginatorIntl.itemsPerPageLabel = 'Items per page';
          paginatorIntl.nextPageLabel = 'Next page';
          paginatorIntl.previousPageLabel = 'Previous page';
          paginatorIntl.getRangeLabel = (page: number, pageSize: number, length: number) => {
            length = this.length;
            if (length == 0 || pageSize == 0) { return `0 van ${length}`; }
            length = Math.max(length, 0);
            const startIndex = page * pageSize;
            const endIndex = startIndex < length ?
              Math.min(startIndex + pageSize, length) :
              startIndex + pageSize;
            const round = Math.ceil(length / 10)
            return `${(startIndex / 10) + 1}  of ${round}`;
          }
          this.clientDataSource.paginator._intl = paginatorIntl;   
        } })
    } else {
      this.parEmployeeService.getParEmployees().subscribe(res => {
        if (res.Status == 200 && res.Employees.length <= 0) {
          this.PAREmployeeList = [];
          this.dataSource = null;
          this.ispaginationFlag = false;
          this.message = 'No employees found';
        }
        else {
          this.PAREmployeeList = [];
          for (let i = 0; i < res.Employees.length; i++) {
            res.Employees[i].FirstName = res.Employees[i].FirstName.toLowerCase();
            res.Employees[i].LastName = res.Employees[i].LastName.toLowerCase();
            this.PAREmployeeList.push(res.Employees[i])
          }
          this.message = '';
          this.dataSource = new MatTableDataSource(this.PAREmployeeList);
          this.length = this.PAREmployeeList.length;
          if (this.length <= 10) {
            this.ispaginationFlag = false;
          }
          else {
            this.ispaginationFlag = true;
          }
          this.paginator.pageIndex = 0;
          this.dataSource.paginator = this.paginator;
          this.dataSource.sort = this.sort;
          const paginatorIntl = new MatPaginatorIntl();
          paginatorIntl.itemsPerPageLabel = 'Items per page';
          paginatorIntl.nextPageLabel = 'Next page';
          paginatorIntl.previousPageLabel = 'Previous page';
          paginatorIntl.getRangeLabel = (page: number, pageSize: number, length: number) => {
            length = this.length;
            if (length == 0 || pageSize == 0) { return `0 van ${length}`; }
            length = Math.max(length, 0);
            const startIndex = page * pageSize;
            const endIndex = startIndex < length ?
              Math.min(startIndex + pageSize, length) :
              startIndex + pageSize;
            const round = Math.ceil(length / 10)
            return `${(startIndex / 10) + 1}  of ${round}`;
          }
          this.dataSource.paginator._intl = paginatorIntl;
        }
      }, 
        err => {
          this.DocListErrMsg = "Get PAREmployee" + err;
          this.DocListErr = true;
        });
    }


  }

  editemployee(docName) { 
    this.editemployees(docName, 'update');
  }


  editemployees(employeeList, type) {
    const dialogRef = this.dialog.open(ParemployeeSummaryComponent, {
      disableClose: true,
      width: '70%',
      height: '60%',
      data: { EmployeeData: employeeList, ListOfEmployees: this.PAREmployeeList }
    });
    dialogRef.afterClosed().subscribe(result => {
    });
  }

  addEmployee() {
    this.addbuttonClicked('create');
  }

  addbuttonClicked(type): void {
    const dialogRef = this.dialog.open(ParemployeeSummaryComponent, {
      disableClose: true,
      width: '70%',
      height: '60%',
      data: { ListOfEmployees: this.PAREmployeeList }
    });
  }
  deleteDoc(data) {
    const dialogRef = this.dialog.open(ParemployeeDelDialogComponent, {
      width: '400px',
      height: '250px',
      data: data
    });
  }

  selectedEmployee(employeeList) {
    this.empName = this.toTitleCase(employeeList.FirstName + " " + employeeList.LastName);
    localStorage.setItem('EmployeeName', this.empName);
    localStorage.setItem('dbId', employeeList._id);
    localStorage.setItem("ParEmployeeID", employeeList.EmployeeId);
    this.router.navigate(['par/employee', 'EmployeeSummary', employeeList.EmployeeId]);
  }
  toTitleCase(str) {
    return str.replace(
      /\w\S*/g,
      function (txt) {
        return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
      }
    );
  }
  
  selectedClientEmployee(employee){
    localStorage.setItem('Employee_Id', employee._id);
    this.router.navigate(['par/employee', 'EmployeeSummary', employee._id]);
  }
}
export interface EmployeeData {
  FirstName: String;
  EmployeeId: String;
  FileEdit: any;
}
export interface clientEmployeeData{
  FirstName: string;
}



// WEBPACK FOOTER //
// ./src/app/components/par-employee/par-employee.component.ts